import type { Media as mediaType } from '@/types/media.type'

export default class Media implements mediaType {
  src = ''
  format = ''
  url = ''
  constructor(media?: mediaType) {
    if (!media) return
    this.src = media.src
    this.format = media.format
    this.url = media.url
  }
}
